<script setup name="TvbPreferredSources">
import { onMounted } from 'vue'
import defaultWeb from '@/assets/img/icon_follow_default_web.svg'
import hoverWeb from '@/assets/img/icon_follow_hover_web.svg'
import defaultMobile from '@/assets/img/icon_follow_default_mobile.svg'
import hoverMobile from '@/assets/img/icon_follow_hover_mobile.svg'

// Google Preferred Sources SDK（高级 JS 实现-自定义设计资产，manual 模式阻止自动渲染官方按钮）
const PUBLISHER_SRC = 'https://news.google.com/swg/js/v1/publisher.js'
let preferredSourceApi = null

// 客户端注入 publisher.js（去重，防止 SPA 路由切换重复插入）
const loadPublisherScript = () => {
  if (document.querySelector(`script[src="${PUBLISHER_SRC}"]`)) return
  const script = document.createElement('script')
  script.async = true
  script.setAttribute('preferred-sources-control', 'manual')
  script.src = PUBLISHER_SRC
  document.head.appendChild(script)
}

onMounted(() => {
  loadPublisherScript()
  // 注册回调队列：SDK 加载前为数组 push、加载后为处理器对象 push，两种时序均有效
  ;(self.PREFERRED_SOURCE = self.PREFERRED_SOURCE || []).push((preferredSource) => {
    preferredSource.init({ theme: 'light' })
    preferredSourceApi = preferredSource
  })
})

// 点击触发 Google 添加首选来源流程（SDK 未就绪时为安全空操作）
const onClick = () => preferredSourceApi?.addPreferredSource()
</script>

<template>
  <button
    type="button"
    class="tvb-preferred-sources"
    aria-label="加入 Google 首選來源"
    @click="onClick"
  >
    <img
      class="tvb-preferred-sources_img _default-web"
      :src="defaultWeb"
      alt=""
      aria-hidden="true"
    />
    <img class="tvb-preferred-sources_img _hover-web" :src="hoverWeb" alt="" aria-hidden="true" />
    <img
      class="tvb-preferred-sources_img _default-mobile"
      :src="defaultMobile"
      alt=""
      aria-hidden="true"
    />
    <img
      class="tvb-preferred-sources_img _hover-mobile"
      :src="hoverMobile"
      alt=""
      aria-hidden="true"
    />
  </button>
</template>

<style scoped lang="scss">
.tvb-preferred-sources {
  // 视觉由整图承担：仅重置按钮默认样式并按断点给定尺寸
  display: inline-block;
  width: 192px;
  min-width: 192px;
  height: 42px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  .tvb-preferred-sources_img {
    display: none;
    width: 100%;
    height: 100%;
  }

  // 默认（>768）：桌面默认态整图
  ._default-web {
    display: block;
  }

  // hover（>768）：整图切换为桌面 hover 态
  &:hover {
    ._default-web {
      display: none;
    }
    ._hover-web {
      display: block;
    }
  }

  // ≤768：切换为移动端整图（180×34）
  @media (max-width: 768px) {
    width: 180px;
    min-width: 180px;
    height: 34px;

    ._default-web {
      display: none;
    }
    ._default-mobile {
      display: block;
    }

    &:hover {
      ._default-web,
      ._hover-web,
      ._default-mobile {
        display: none;
      }
      ._hover-mobile {
        display: block;
      }
    }
  }
}
</style>
